/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var TYPE = 'reports';
    var ADMIN_FORM_ID = 'updateFrm';
    var GRID_ID = 'grid';
    var SEARCH_FRM_NAME = 'searchFrm';
    var _a = ezdia.templates.reporting, rowMarkupTemplate = _a.rowMarkup, infoMarkupTemplate = _a.infoMarkup, imgPreviewMarkupTemplate = _a.imgPreviewMarkup, adminFormMarkupTemplate = _a.adminFormMarkup, reportDownloadMarkupTemplate = _a.reportDownloadMarkup;
    var INFO_PANEL_FIELDS = [
        'label',
        'description',
        'type',
        'solutions',
        'preview'
    ];
    var ADMIN_INFO_PANEL_FIELDS = [
        'user_types',
        'subscribed_users',
        'blacklist_users'
    ];
    var Reporting = /** @class */ (function () {
        function Reporting() {
        }
        Reporting.prototype.render = function () {
            this.load();
            this.search();
            this.renderGrid();
            pageLoadingDone();
        };
        Reporting.prototype.renderForm = function (ids) {
            ezdia.component.form.show();
            $.ezdia.loading.show();
            var rowdataAndCols = this.getSelectedRowDataAndCols(ids);
            this.curSelection.reportName = this.curSelection.data.name;
            this.renderItem(rowdataAndCols);
            this.renderDownloadReports();
        };
        Reporting.prototype.load = function () {
            this.curSelection = {};
            this.pageParams = $.ezdia.config.pageParams;
            ezdia.component.form.closeFormBtn('ez-js-form-right-close');
            $('#updateBtn')
                .off('click')
                .on('click', handelAdminConfigSubmit.bind(this));
        };
        Reporting.prototype.search = function () {
            var pageParams = $.ezdia.config.pageParams || {};
            var searchObj = {
                advance: {
                    queryfields: pageParams.searchFieldsJson
                },
                callbacks: {
                    search: this.renderGrid.bind(this)
                }
            };
            if (pageParams.basicSearchFields.length > 0) {
                searchObj = $.extend(true, {}, searchObj, {
                    enablebasic: true,
                    basic: {
                        queryfields: pageParams.basicSearchFields
                    }
                });
            }
            if (pageParams.requestParam) {
                searchObj.requestParam = pageParams.requestParam;
            }
            $("#" + SEARCH_FRM_NAME).search(searchObj);
        };
        Reporting.prototype.onSelectRow = function (self, ids, clicked) {
            var grid = $(this);
            self.curSelection = {};
            hideShowDeskForm();
            if (!clicked) {
                grid.jqGrid('resetSelection');
                ezdia.component.form.hide();
                return;
            }
            self.renderForm(ids);
        };
        Reporting.prototype.renderGrid = function () {
            var e_1, _a;
            var self = this;
            var _b = this.pageParams, colNames = _b.colNames, colModel = _b.colModel, formType = _b.formType, account = _b.account;
            try {
                for (var colModel_1 = __values(colModel), colModel_1_1 = colModel_1.next(); !colModel_1_1.done; colModel_1_1 = colModel_1.next()) {
                    var col = colModel_1_1.value;
                    col.sortable = false;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (colModel_1_1 && !colModel_1_1.done && (_a = colModel_1.return)) _a.call(colModel_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            ezdia.component.grid.create({
                id: GRID_ID,
                classes: 'ez-jqgrid-reports',
                url: 'ReportCatalogData.htm',
                datatype: 'json',
                mtype: 'POST',
                postData: {
                    formtype: function () {
                        return formType;
                    },
                    accountName: function () {
                        return account;
                    },
                    searchCondition: function () {
                        return $("#" + SEARCH_FRM_NAME).search('getQueryString');
                    },
                    date: new Date()
                },
                shrinkToFit: true,
                colNames: colNames,
                colModel: colModel,
                caption: '',
                columnChooser: false,
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true,
                loadComplete: this.loadComplete,
                onSelectRow: function (ids, clicked) {
                    self.onSelectRow.call(this, self, ids, clicked);
                }
            });
        };
        Reporting.prototype.loadComplete = function () {
            var recordCount = $('#grid').jqGrid('getGridParam', 'records');
            var gridCaption = ezdia.templates.grid.caption("Total " + recordCount + " Reports");
            $('#grid').jqGrid('setCaption', gridCaption);
            hideShowDeskForm();
            ezdia.component.form.hide();
        };
        Reporting.prototype.getSelectedRowDataAndCols = function (rowId) {
            var _this = this;
            var _a = this.pageParams, jqGridRowsData = _a.jqGridRowsData, colModel = _a.colModel;
            var rowdata = jqGridRowsData.rows.filter(function (_a) {
                var id = _a.id;
                return id === rowId;
            });
            var length = rowdata.length;
            this.curSelection.data = {};
            this.curSelection.colsAndVal = {};
            if (length) {
                var data_1 = rowdata[0].cell;
                colModel.map(function (col, index) {
                    var colsAndVal = {
                        column: col,
                        value: data_1[index]
                    };
                    _this.curSelection.data[col.name] = data_1[index];
                    _this.curSelection.colsAndVal[col.name] = colsAndVal;
                    return colsAndVal;
                });
            }
            return this.curSelection.colsAndVal;
        };
        Reporting.prototype.renderItem = function (cols) {
            $.ezdia.widgets.load(TYPE);
            var isAdmin = $.ezdia.config.pageParams.isAdmin;
            var infolHTML = this.getInfoPanelHTML(cols);
            var subscribeBtns = this.getSubscribeHTML(cols);
            var adminConfigHTML = '';
            // TODO: REMOVE THIS ONCE NEW CODE IS IMPLEMENTED
            if (isAdmin && ezdia.config.user) {
                isAdmin = ezdia.config.user.is_admin;
            }
            if (isAdmin) {
                adminConfigHTML = this.getAdminPanelHTML(cols);
            }
            $('#content').html(infolHTML + subscribeBtns + adminConfigHTML);
            $.ezdia.widgets.create(TYPE);
            $('#updateBtnContainer').show();
            $.ezdia.loading.hide();
        };
        Reporting.prototype.getInfoPanelHTML = function (cols) {
            var e_2, _a;
            var HTMLMarkupArray = [];
            var imagePrev = '';
            try {
                for (var INFO_PANEL_FIELDS_1 = __values(INFO_PANEL_FIELDS), INFO_PANEL_FIELDS_1_1 = INFO_PANEL_FIELDS_1.next(); !INFO_PANEL_FIELDS_1_1.done; INFO_PANEL_FIELDS_1_1 = INFO_PANEL_FIELDS_1.next()) {
                    var name_1 = INFO_PANEL_FIELDS_1_1.value;
                    var col = cols[name_1];
                    var column = col.column;
                    var content = void 0;
                    var rowMarkup = void 0;
                    if (name_1 === 'preview') {
                        content = this.getImgPreviewContent(col);
                    }
                    else {
                        content = $.ezdia.inputs.readonlyView(col, TYPE);
                    }
                    if (name_1 === 'preview') {
                        imagePrev = content;
                    }
                    else {
                        rowMarkup = rowMarkupTemplate(__assign(__assign({}, column), { content: content }));
                    }
                    HTMLMarkupArray.push(rowMarkup);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (INFO_PANEL_FIELDS_1_1 && !INFO_PANEL_FIELDS_1_1.done && (_a = INFO_PANEL_FIELDS_1.return)) _a.call(INFO_PANEL_FIELDS_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var fieldMarkup = HTMLMarkupArray.join('');
            var HTMLMarkup = infoMarkupTemplate(fieldMarkup, imagePrev);
            return HTMLMarkup;
        };
        Reporting.prototype.getSubscribeHTML = function (cols) {
            var data = this.curSelection.data;
            var farray = [];
            if (data.type !== 'email') {
                farray.push('dashboard_subscription');
            }
            if (data.type !== 'dashboard') {
                farray.push('email_subscription');
                farray.push('available_frequency');
            }
            return this.getFormHTML(cols, farray);
        };
        Reporting.prototype.getAdminPanelHTML = function (cols) {
            return this.getFormHTML(cols, ADMIN_INFO_PANEL_FIELDS);
        };
        Reporting.prototype.getFormHTML = function (cols, fields) {
            var e_3, _a;
            var HTMLMarkupArray = [];
            try {
                for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                    var fname = fields_1_1.value;
                    var col = cols[fname];
                    var column = col.column;
                    var editable = column.editable, name_2 = column.name;
                    var content = void 0;
                    if (name_2 === 'available_frequency') {
                        setAvailableFrequencyConfig(column, cols);
                    }
                    if (editable) {
                        content = $.ezdia.inputs.create(col, TYPE);
                        $.ezdia.widgets.init(col, TYPE);
                    }
                    else {
                        content = $.ezdia.inputs.readonlyView(col, TYPE);
                    }
                    var rowMarkup = rowMarkupTemplate(__assign(__assign({}, column), { content: content, cls: name_2 === 'available_frequency' || name_2 === 'email_subscription'
                            ? 'info-row-inline'
                            : '' }));
                    HTMLMarkupArray.push(rowMarkup);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            var fieldMarkup = HTMLMarkupArray.join('');
            var HTMLMarkup = adminFormMarkupTemplate(fieldMarkup);
            return HTMLMarkup;
        };
        Reporting.prototype.getImgPreviewContent = function (_a) {
            var value = _a.value;
            var arr = ezdia.util.jsonParse(value);
            var retVal = '';
            if (arr && arr.length) {
                retVal = imgPreviewMarkupTemplate(arr[0]);
            }
            return retVal;
        };
        Reporting.prototype.renderDownloadReports = function () {
            var reportName = this.curSelection.reportName;
            handleBackgroundAjax({
                data: {
                    report_name: reportName
                },
                url: 'fetchPreviousData.htm',
                callback: this.populatePreviousVersions
            });
        };
        Reporting.prototype.populatePreviousVersions = function (reportData) {
            if (!reportData) {
                return;
            }
            var reportDataJson = ezdia.util.jsonParse(reportData);
            $('#content').append(reportDownloadMarkupTemplate(reportDataJson));
        };
        return Reporting;
    }());
    function setAvailableFrequencyConfig(column, cols) {
        var e_4, _a;
        var value = cols.available_frequency.value;
        if (!value) {
            return;
        }
        var options = {};
        var valArrays = value.replace('{', '').replace('}', '').split(',');
        var cronTime;
        if (cols.cron_time) {
            cronTime = cols.cron_time.value;
        }
        try {
            for (var valArrays_1 = __values(valArrays), valArrays_1_1 = valArrays_1.next(); !valArrays_1_1.done; valArrays_1_1 = valArrays_1.next()) {
                var valStr = valArrays_1_1.value;
                var _b = __read(valStr.split('='), 2), key = _b[0], val = _b[1];
                var keyTrim = key.trim();
                options[keyTrim] = val;
                if (keyTrim === cronTime && cronTime) {
                    cols.available_frequency.value = cronTime;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (valArrays_1_1 && !valArrays_1_1.done && (_a = valArrays_1.return)) _a.call(valArrays_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        column.config = __assign(__assign({}, column.config), { options: __assign({}, options) });
    }
    function handelAdminConfigSubmit() {
        var data = $("#" + ADMIN_FORM_ID).serializeArray();
        var reportName = this.curSelection.reportName;
        data.push({
            name: 'report_name',
            value: reportName
        });
        handelAjaxSubmit({
            data: data,
            url: 'saveReportSettings.htm'
        });
    }
    function handelAjaxSubmit(_a) {
        var data = _a.data, _b = _a.url, url = _b === void 0 ? 'saveSubscriptionDetails.htm' : _b, callback = _a.callback;
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function (_a) {
                var success = _a.success, msg = _a.msg;
                $.ezdia.loading.hide();
                if (success) {
                    if (callback) {
                        callback();
                    }
                    ezdia.util.showSuccessError({
                        message: msg
                    });
                    ezdia.component.form.hide();
                    $("#" + GRID_ID).trigger('reloadGrid');
                }
                else {
                    ezdia.util.showSuccessError({
                        message: msg,
                        error: true,
                        autohide: false
                    });
                }
            },
            error: function () {
                $.ezdia.loading.hide();
            }
        });
    }
    function handleBackgroundAjax(_a) {
        var data = _a.data, _b = _a.url, url = _b === void 0 ? '' : _b, callback = _a.callback;
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function (_a) {
                var success = _a.success, msg = _a.msg;
                $.ezdia.loading.hide();
                if (success) {
                    if (callback) {
                        callback(msg);
                    }
                }
                else {
                    ezdia.util.showSuccessError({
                        message: msg,
                        error: true,
                        autohide: false
                    });
                }
            },
            error: function () {
                $.ezdia.loading.hide();
            }
        });
    }
    var pages;
    (function (pages) {
        pages.reporting = new Reporting();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
